import React from 'react'

export const EngagementTooltips = {
  'Share career journey and answer questions': {
    title: 'Share career journey and answer questions',
    content:
      'The industry professional can join your classroom to share their own personal career journey and answer student questions about the career and industry.',
  },
  'Promote internship opportunities': {
    title: 'Promote internship opportunities',
    content:
      'Connect with an industry professional to discuss internship opportunities for students at their company.',
  },
  'Provide content/subject consultation with a class': {
    title: 'Provide content/subject consultation with a class',
    content: (
      <div>
        <p>
          The industry professional can join your classroom to discuss how your
          curriculum content/subject areas connect to the genuine work being
          done in industry.
        </p>
        <br />
        <p>
          <em>
            Ex. A healthcare professional discusses how students' understanding
            of human body systems connects to diagnosing and treating patients
            or developing new treatments.
          </em>
        </p>
        <p>
          <em>
            Ex. A software developer explains how coding and problem-solving
            skills from the curriculum are used to build applications that
            improve patient care or streamline hospital operations.
          </em>
        </p>
      </div>
    ),
  },
  'Support students with a classroom project by asking questions and linking current industry standards to the project': {
    title:
      'Support students with a classroom project by asking questions and linking current industry standards to the project',
    content: (
      <div>
        <p>
          The industry professional can meet with small groups during classroom
          projects to ask questions. By asking questions and offering insights
          from their experience, the professional helps students think
          critically, refine their designs, and stay focused on project goals
          aligned with industry practices.
        </p>
        <br />
        <p>
          <em>
            Ex. In an 8th grade life science class, students are working in
            small groups on a project to design a public health campaign about
            preventing the spread of infectious diseases. The industry
            professional meets with each group during project time and asks
            questions.
          </em>
        </p>
      </div>
    ),
  },
  'Consult with a teacher on designing a real-world classroom project': {
    title: 'Consult with a teacher on designing a real-world classroom project',
    content: (
      <div>
        <p>
          Use the industry professional to help you plan a project that is
          connected to industry standards and models real-world examples.
        </p>
        <br />
        <p>
          <em>
            Ex. The teacher is developing a classroom project using the design
            thinking process (DTP). They ask the industry professional to share
            how they apply the steps of design thinking in their own field,
            providing real-world insights that can help shape the students'
            project approach.
          </em>
        </p>
      </div>
    ),
  },
  'Become a member of a CTE Advisory Committee': {
    title: 'Become a member of a CTE Advisory Committee',
    content:
      'Industry professionals are available to assist with your CTE program and offer suggestions for curriculum and skills with their industry.',
  },
  'Participate in an exhibit or school fair': {
    title: 'Participate in an career exhibit event',
    content:
      'Invite one or more industry professionals to your event to represent their company or industry.',
  },
  'Participate as a judge at an event (e.g. science fair)': {
    title: 'Participate as a judge at an event (e.g. science fair)',
    content:
      'Invite one or more industry professionals to participate as judge for a science or CTE fair or event.',
  },
}

export const getEngagementTooltip = (expectation: string) => {
  return EngagementTooltips[expectation as keyof typeof EngagementTooltips]
}
